import { GetterTree } from 'vuex';
import { AnswersState } from '.';
import { AppState } from '../app';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import { StateViewModel } from '@/features/bots/models/designer';
import { TransitionType } from '@/features/bots/models/designer/transitionType';
import { TransitionPickerConfig } from '@/features/bots/models/designer/transitionPickerConfig';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';

export const getters: GetterTree<AnswersState, AppState> = {
  isAnswerTransitioningToAnInactiveFlow(answerState: AnswersState, localGetters, rootState: any): boolean {
    const states = answerState.currentAnswer.answerStates;
    if (!hasGoToState(states)) {
      return false;
    }
    const transition = states[states.length - 1].transition!.payload;
    const flow = rootState.flowDesigner.flows.find((f: any) => f.id === transition);
    return !flow ? false : flow.status !== FlowStatus.Live;
  },

  transitionPickerConfigForAnswer(answerState: AnswersState, localGetters, rootState: any): TransitionPickerConfig {
    const flows = getFlowsForTransitionPicker(rootState.flowDesigner.flows, answerState.currentAnswer.status);
    const options = [
      ...flows.map((flow: FlowListItemViewModel) => ({
        id: flow.id,
        name: flow.name,
        type: TransitionType.Flow,
      })),
    ];

    return { currentStatus: answerState.currentAnswer.status, options, allowAddPath: false };
  },
};

function hasGoToState(states: StateViewModel[]) {
  if (states.length === 0) {
    return false;
  }
  const lastState = states[states.length - 1];
  return lastState.transition && lastState.transition.payload;
}

function getFlowsForTransitionPicker(
  flows: FlowListItemViewModel[],
  currentStatus: FlowStatus,
): FlowListItemViewModel[] {
  if (currentStatus === FlowStatus.Live) {
    return flows.filter((flow: FlowListItemViewModel) => flow.status === FlowStatus.Live);
  }
  return flows;
}
